module.exports = __webpack_public_path__ + "static/assets/dbd143918003892a87ae09758a5243e4.png";